import React, { useEffect, useState } from "react";

import { getVPSRealtime } from "../../../../services/vps.api";
import { useTimezone } from "../../../../hooks/useTimezone";
import ServiceRow from "./ServiceRow";

const REFRESH_MS = 15 * 1000;

/**
 * Socket.IO dentro de «Servicios» (doc 0447, D6): lo único con valor propio que tenía la
 * antigua pestaña «Aplicación». Los contadores viven en memoria y se reinician al
 * arrancar el backend, por eso se dice desde cuándo cuentan.
 */
const RealtimeServiceRow = () => {
  const { formatDateTime } = useTimezone();
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data: res } = await getVPSRealtime();
        if (!alive) return;
        setData(res.data);
        setFailed(false);
      } catch {
        if (alive) setFailed(true);
      }
    };
    load();
    const id = setInterval(load, REFRESH_MS);
    return () => {
      alive = false;
      clearInterval(id);
    };
  }, []);

  if (failed) return <ServiceRow name="Socket.IO" status="warning" value="Sin datos" />;
  if (!data) return <ServiceRow name="Socket.IO" value="…" />;
  return (
    <ServiceRow
      name="Socket.IO"
      status="ok"
      value={`${data.activeConnections} conexiones · ${data.eventsPerMinute} eventos/min`}
      hint={`Contando desde ${formatDateTime(data.countingSince)}`}
    />
  );
};

export default RealtimeServiceRow;
